export const GAME_BET_VALUE = 'betValue'
export const GAME_BUILD_ID = 'buildId'
export const GAME_FULLSCREEN = 'fullscreen'
export const GAME_OUT_OF_CREDITS = 'outOfCredits'
export const GAME_MENU_SHOWN = 'menuShown'
export const GAME_SOUND_ENABLED = 'soundEnabled'
export const GAME_STATE = 'state'
export const GAME_SESSION_TIME = 'gameSessionTime'
export const ACCEPTED_GAME_TERMS = 'acceptedGameTerms'
